<p-dialog
  #fastProcedimento
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar procedimento</span>
      <i class="mdi mdi-bandage ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-md-10 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label for="inputtext-nome">Nome</mat-label>
        <input
          id="inputtext-nome"
          class="input-filters"
          matInput
          [formControl]="form.get('nome')"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('nome').hasError('duplicate')">
        {{ displayMessage.nome.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.required }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('maxlength')">
        {{ displayMessage.nome.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('isEmptyValue')">
        {{ displayMessage.nome.isEmptyValue }}
      </small>
    </div>
    <div (click)="vlUnt.select()" class="col-md-2 mt-3">
      <mat-form-field
        class="width-100"
        appearance="outline"
        (click)="vlUnt.select()"
      >
        <mat-label (click)="vlUnt.select()">Valor</mat-label>
        <input
          #vlUnt
          matInput
          (click)="vlUnt.select()"
          mask="separator.2"
          decimalMarker=","
          separatorLimit="1000000000000"
          type="text"
          [formControl]="form.get('valor')"
          style="text-align: right;"
        />
        <span matPrefix>R$&nbsp;</span>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('valor').hasError('invalidNumber')"
      >
        {{ displayMessage.valor.invalidNumber }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('required')">
        {{ displayMessage.valor.required }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('valueMinZero')">
        {{ displayMessage.valor.valueMinZero }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('menor_valor')">
        {{ displayMessage.valor.menor_valor }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('notNumbers')">
        {{ displayMessage.valor.notNumbers }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('before_split')">
        {{ displayMessage.valor.before_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('after_split')">
        {{ displayMessage.valor.after_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorComma')">
        {{ displayMessage.valor.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorDots')">
        {{ displayMessage.valor.errorDots }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('max_value')">
        {{ displayMessage.valor.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('valor').hasError('existSpecialChar')"
      >
        {{ displayMessage.valor.existSpecialChar }}
      </small>
    </div>
    <fast-autocomplete
      #input
      [autoFirst]="false"
      id="field-tipo-procedimento"
      placeholder="Tipo de procedimento"
      required
      class="col-md-12 mt-2"
      displayField="descricao"
      [controlIsEnable]="form.get('tipo_procedimento').enabled"
      [messages]="{
        required: 'Tipo de procedimento é obrigatório',
        isEmptyValue: 'Inválido! Remova os espaços em branco!',
        typeIs: 'Valor inválido!'
      }"
      (clearSelection)="form.get('tipo_procedimento').reset()"
      [value_order]="'descricao'"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [control]="form.get('tipo_procedimento')"
      [entityService]="tipoProcedimentoService"
      [domain_id]="tokenService.getDomain().id"
      [initDataWithEmpty]="true"
      [insertType]="'tipo_procedimento'"
      [actionState]="
        verificarDisponibilidade({
          method: 'POST',
          params: '',
          url: '/tipos_procedimento'
        })
      "
    ></fast-autocomplete>
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <textarea
          rows="8"
          cols="118"
          pInputTextarea
          style="resize: none;"
          id="inputtext-descricao"
          [formControl]="form.get('descricao')"
          class="input-filters"
        ></textarea>
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <mat-hint
        class="flex width-100 justify-content-end"
        *ngIf="form.get('descricao').valid"
      >
        {{
          form.controls.descricao.value
            ? form.controls.descricao.value.length
            : 0
        }}/500
      </mat-hint>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('duplicate')"
      >
        {{ displayMessage.descricao.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
